import React, { useState, useRef } from "react";
import { Grid, Input, MenuItem, Select, InputLabel, Typography, FormGroup } from "@mui/material";
import CountrySelect from "../../../CountrySelect";
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import TextField from '@mui/material/TextField';
import Paper from "@mui/material/Paper";

const ParentDetails = ({
    setMotherName, motherNameValue,
    setMotherEmail, motherEmailValue,
    setMotherOccupation, motherOccupationValue,
    setFatherName, fatherNameValue,
    setFatherEmail, fatherEmailValue,
    setFatherOccupation, fatherOccupationValue,
    setMotherPhone, motherPhone,
    setFatherPhone, fatherPhone,
    setUnsupervisedFreeTime, unsupervisedFreeTime,
    editVersion, hideTitle,
    isFormInvalid,
    readonly
}) => {
    return (
        <Paper elevation={3} display="flex" className={"step-container"}>
            <Box sx={{ color: 'primary.main' }}>
                {!hideTitle ?
                    <Typography fontSize={20} fontWeight={'bold'} marginBottom={2} marginTop={2} align="left">
                        Parent/Guardian details
                    </Typography> : <></>
                }
            </Box>
            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                <Grid item xs={6}>
                    <Typography fontSize={20} fontWeight={'bold'} marginBottom={2} marginTop={2} align="left">
                        Guardian 1
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography fontSize={20} fontWeight={'bold'} marginBottom={2} marginTop={2} align="left">
                        Guardian 2
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <label htmlFor="mothername">Name *</label>
                    <TextField
                        type="text"
                        size="small"
                        className="form-control"
                        name="mothername"
                        disabled={readonly}
                        value={motherNameValue}
                        onChange={(e) => setMotherName(e.target.value)}
                        error={isFormInvalid && (motherNameValue == "" || motherNameValue == null)}
                        inputProps={{ maxLength: 100 }}
                    />
                </Grid>
                <Grid item xs={6} >
                    <label htmlFor="fathername">Name *</label>
                    <TextField
                        type="text"
                        size="small"
                        className="form-control"
                        disabled={readonly}
                        name="fathername"
                        value={fatherNameValue}
                        onChange={(e) => setFatherName(e.target.value)}
                        error={isFormInvalid && (fatherNameValue == "" || fatherNameValue == null)}
                        inputProps={{ maxLength: 100 }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <label htmlFor="motherphone">Phone *</label>
                    <TextField
                        type="phone"
                        size="small"
                        className="form-control"
                        disabled={readonly}
                        name="motherphone"
                        value={motherPhone}
                        onChange={(e) => setMotherPhone(e.target.value)}
                        error={isFormInvalid && (motherPhone == "" || motherPhone == null)}
                        inputProps={{ maxLength: 50 }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <label htmlFor="fatherphone">Phone *</label>
                    <TextField
                        type="phone"
                        size="small"
                        className="form-control"
                        disabled={readonly}
                        name="fatherphone"
                        value={fatherPhone}
                        onChange={(e) => setFatherPhone(e.target.value)}
                        error={isFormInvalid && (fatherPhone == "" || fatherPhone == null)}
                        inputProps={{ maxLength: 50 }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <label htmlFor="motheremail">Email address</label>
                    <TextField
                        type="text"
                        disabled={readonly}
                        size="small"
                        className="form-control"
                        name="motheremail"
                        value={motherEmailValue}
                        onChange={(e) => setMotherEmail(e.target.value)}
                        inputProps={{ maxLength: 100 }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <label htmlFor="fatheremail">Email address</label>
                    <TextField
                        type="text"
                        size="small"
                        disabled={readonly}
                        className="form-control"
                        name="fatheremail"
                        value={fatherEmailValue}
                        onChange={(e) => setFatherEmail(e.target.value)}
                        inputProps={{ maxLength: 100 }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <label htmlFor="motheroccupation">Occupation</label>
                    <TextField
                        type="text"
                        size="small"
                        disabled={readonly}
                        className="form-control"
                        name="motheroccupation"
                        value={motherOccupationValue}
                        onChange={(e) => setMotherOccupation(e.target.value)}
                        inputProps={{ maxLength: 100 }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <label htmlFor="fatheroccupation">Occupation</label>
                    <TextField
                        type="text"
                        disabled={readonly}
                        size="small"
                        className="form-control"
                        name="fatheroccupation"
                        value={fatherOccupationValue}
                        onChange={(e) => setFatherOccupation(e.target.value)}
                        inputProps={{ maxLength: 100 }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControl error={(isFormInvalid && unsupervisedFreeTime == null)}>
                        {!editVersion ?
                            <FormLabel align="left">During the weekend excursions, your child will have the opportunity to go shopping. During this time they may be unsupervised but are not
                                alone. LINES insists that they must do this activity in groups of minimum 2 or 3.
                                Students go shopping in shopping malls or pedestrianised shopping streets. Our staff are present and contactable by phone at all times and are
                                waiting for the students at designated areas and times. The same arrangements apply to the Sunday optional excursions.
                                Do you give permission for your child to be unsupervised during this time ? *
                            </FormLabel> :
                            <FormLabel>Unsupervised FreeTime</FormLabel>}
                        <RadioGroup row>
                            <FormControlLabel control={<Radio value={1} checked={unsupervisedFreeTime == 1} disabled={readonly} onChange={(e) => setUnsupervisedFreeTime(e.target.value)} />} label="Yes" />
                            <FormControlLabel control={<Radio value={0} checked={unsupervisedFreeTime == 0} disabled={readonly} onChange={(e) => setUnsupervisedFreeTime(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>

                </Grid>

            </Grid>
        </Paper>)
}

export default ParentDetails